import { RouteObject } from "react-router-dom";
import { getRoutes, NavbarRoutes } from "./NavBarRoutes";
import ErrorBoundary from "./utils/ErrorBoundary";

export const MainController = () => {
  const routes = getRoutes();

  const registerRoutes = function (route: NavbarRoutes) {
    if (route.isActivePage) {
      routesConfig.push({
        path: ("/" + route.routerPath) as string,
        element: <ErrorBoundary>{route.control}</ErrorBoundary>,
      });
    }

    route.children?.map((x) => registerRoutes(x));
  };

  var routesConfig: RouteObject[] = [];
  for (let index = 0; index < routes.length; index++) {
    registerRoutes(routes[index]);
  }

  const getRoutesConfig = (): RouteObject[] => {
    return routesConfig;
  };

  const getMenuItems = (): NavbarRoutes[] => {
    return routes;
  };

  return {
    getRoutesConfig,
    getMenuItems,
  };
};
